import { ComponentType } from "react";
import { ContentbarProps, ISelectList } from "./ContentSideComp";

interface IExtenanlContentSideChoicerProps {
    nameOrg: string;
    index: number;
    isCollapsed: boolean;
}

interface IContentSideChoicer {
    RenderComponentCriteria: boolean;
    SelectSidebarComponent: ComponentType<ContentbarProps<ISelectList>>;
    NormalSidebarComponent: ComponentType<ContentbarProps<ISelectList>>;
    content: ContentbarProps<ISelectList>;
    ExternalProps: IExtenanlContentSideChoicerProps;
    isCurrentPage: boolean;
    isAdminConsolePage: boolean;
}

export function ContentSideChoicer({
    NormalSidebarComponent,
    RenderComponentCriteria,
    SelectSidebarComponent,
    content,
    ExternalProps,
    isCurrentPage,
    isAdminConsolePage,
}: IContentSideChoicer) {
    if (RenderComponentCriteria) {
        return <SelectSidebarComponent 
            children={content.children}
            icon={content.icon!}
            key={ExternalProps.index}
            anchorElSelect={content.anchorElSelect}
            handleClickSelect={content.handleClickSelect}
            handleCloseSelect={content.handleCloseSelect}
            nameOrg={ExternalProps.nameOrg}
            onChangeSelection={content.onChangeSelection}
            openSelect={content.openSelect}
            selectList={content.selectList}
            selectValue={content.selectValue}
            isCollapsed={ExternalProps.isCollapsed}
            disabled={content.disabled}
            onClick={content.onClick}
            conditional={content.conditional}
            fill={content.fill}
            title={content.title}
            footer={content.footer}
            isSelect={content.isSelect}
            isSelectField={content.isSelectField}
            renderOption={content.renderOption}
            currentPage={content.currentPage}
            isCurrentPage={isCurrentPage}
            isAdminConsolePage={isAdminConsolePage}
            isNameOption={content.isNameOption}            
            setHovered={content.setHovered}
            setSelected={content.setSelected}
            isWorkspace={content.isWorkspace}
        />
    }

    return <NormalSidebarComponent 
        children={content.children}
        onClick={content.onClick}
        conditional={content.conditional}
        fill={content.fill}
        icon={content.icon}
        title={content.title}
        footer={content.footer}
        key={ExternalProps.index}
        isSelect={content.isSelect}
        isSelectField={content.isSelectField}
        nameOrg={ExternalProps.nameOrg}
        isCollapsed={ExternalProps.isCollapsed}
        disabled={content.disabled}
        renderOption={content.renderOption}
        anchorElSelect={content.anchorElSelect}
        handleClickSelect={content.handleClickSelect}
        handleCloseSelect={content.handleCloseSelect}
        onChangeSelection={content.onChangeSelection}
        openSelect={content.openSelect}
        selectList={content.selectList}
        selectValue={content.selectValue}
        currentPage={content.currentPage}
        isCurrentPage={isCurrentPage}
        isAdminConsolePage={isAdminConsolePage}
        isNameOption={content.isNameOption}
        setHovered={content.setHovered}
        setSelected={content.setSelected}
    />
}